export const detectIfEmpty = (record) => {
  return Object.entries(record)
    .filter(([key]) => !['uuid', 'name', 'key'].includes(key))
    .every(([, value]) => value === null)
}
